import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { get, del, put } from '../../controllers/apiController';

import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

const MusteriTipleri = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [musteriTipleri, setMusteriTipleri] = useState([]);
    const [selectedMusteriTipi, setSelectedMusteriTipi] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);

    useEffect(() => {
        document.title = "Müşteri Tipleri | LEVELUP CRM";

        const fetchMusteriTipleri = async () => {
            try {
                const res = await get("customer-types");

                const musteriTipleriMapped = res.map(musteriTipi => {
                    return {
                        id: musteriTipi.Musteri_Tipi_ID,
                        ad: musteriTipi.Musteri_Tipi_Adi,
                        arkaRenk: musteriTipi.Musteri_Tipi_Renk,
                        yaziRenk: musteriTipi.Musteri_Tipi_Yazi_Renk
                    }
                });

                setMusteriTipleri(musteriTipleriMapped);

                setIsLoading(false);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
        }

        fetchMusteriTipleri();
    }, []);

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Müşteri Tipi Silinsin mi?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await del(`customer-types/${id}`);

                setMusteriTipleri(musteriTipleri.filter(musteriTipi => musteriTipi.id !== id));

                toast.success('Müşteri tipi başarıyla silindi');
            }
        })

    }

    const handleEdit = (musteriTipi) => {
        setSelectedMusteriTipi(musteriTipi);
        setShowEditModal(true);
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {
            await put('customer-types', {
                customerTypeId: selectedMusteriTipi.id,
                customerTypeName: selectedMusteriTipi.ad,
                customerTypeBgColor: selectedMusteriTipi.arkaRenk,
                customerTypeTextColor: selectedMusteriTipi.yaziRenk
            });

            setMusteriTipleri(musteriTipleri.map(musteriTipi =>
                musteriTipi.id === selectedMusteriTipi.id ? selectedMusteriTipi : musteriTipi
            ));

            setShowEditModal(false);
            toast.success('Müşteri tipi başarıyla güncellendi');
        } catch (error) {
            toast.error('Müşteri tipi güncellenirken bir hata oluştu');
        }
    }

    const columns = [
        {
            name: 'Müşteri Tipi Önizlemesi',
            sortable: true,
            cell: row => (
                <div
                    style={{
                        backgroundColor: row.arkaRenk,
                        borderRadius: '6px',
                        padding: '8px 12px',
                        color: row.yaziRenk,
                        fontSize: '14px'
                    }}
                >
                    {row.ad}
                </div>
            )
        },
        {
            name: 'Aksiyon',
            cell: row => (
                <div className="d-flex gap-2">
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleEdit(row)}>
                        <i className="feather feather-edit fs-6"></i>
                    </a>
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleDelete(row.id)}>
                        <i className="feather feather-trash fs-6"></i>
                    </a>
                </div>
            )
        }
    ];

    const modalBackdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1040
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Müşteri Tipleri</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Tüm Müşteri Tipleri</h5>
                                        <div className="card-header-action">
                                            <a href="./create-customer-type" className="btn btn-light">
                                                <i className="feather-plus"></i>
                                                Yeni Ekle
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={musteriTipleri}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {showEditModal && selectedMusteriTipi && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Müşteri Tipi Düzenle</h5>
                                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                            </div>
                            <form onSubmit={handleEditSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Müşteri Tipi Adı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={selectedMusteriTipi.ad}
                                            onChange={(e) => setSelectedMusteriTipi({ ...selectedMusteriTipi, ad: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Arka Plan Rengi</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color w-100"
                                            value={selectedMusteriTipi.arkaRenk}
                                            onChange={(e) => setSelectedMusteriTipi({ ...selectedMusteriTipi, arkaRenk: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Yazı Rengi</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color w-100"
                                            value={selectedMusteriTipi.yaziRenk}
                                            onChange={(e) => setSelectedMusteriTipi({ ...selectedMusteriTipi, yaziRenk: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary">Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {showEditModal && (
                <div style={modalBackdropStyle} onClick={() => setShowEditModal(false)} />
            )}
        </Layout>
    );
};

export default MusteriTipleri;
